import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import IntegrationStageTransactionStatusAppResource from "./IntegrationStageTransactionStatusAppResource";

export const LOST = 'e7aab77b-c291-4dea-a4a0-915076fdc758';
export const PROSPECT = '8d69c962-f4c9-4d6e-a51c-95c5b9648973';
export const COMMITTED = '1a8ba4af-e2e5-4859-9618-f6ec7b2ff660';
export const PENDING = '0ad954dc-91c1-4701-958f-d0a9c5741e4c';
export const CLOSED = 'e0a034bc-9726-460c-ba58-bf1385408f89';

export const OPTIONS = [
    {
        text: 'Lost',
        value: LOST,
    },
    {
        text: 'Prospect',
        value: PROSPECT,
    },
    {
        text: 'Committed',
        value: COMMITTED,
    },
    {
        text: 'Pending',
        value: PENDING,
    },
    {
        text: 'Closed',
        value: CLOSED,
    },
];

class LuTransactionStatusAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-transaction-status';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/transaction/status';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            integrationStageTransactionStatus: IntegrationStageTransactionStatusAppResource
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            }
        };
    }

}

export default LuTransactionStatusAppResource;
